const main = require("./main/main.js");
module.exports = main;


//////////////////
// WEBPACK FOOTER
// ./node_modules/gradient-from-image/index.js
// module id = Q9KP
// module chunks = 0